<script>
import { ViewQuery } from '@acs/components-library/src/gql/live/UnitDetailHistoryChart.js';
import ChartWrapper from '@acs/components-library/src/components/deviceDetail/historyChart/ChartWrapper.vue';
import DateRangeSelector from '@acs/components-library/src/components/deviceDetail/protocols/DateRangeSelector.vue';
import { isDemo } from '@acs/components-library/src/demo.js';
import { getChartDemoData } from '@acs/components-library/src/demo/chartDemoData.js';

export default {
  components: {
    ChartWrapper,
    // BtnComponent,
    // IconComponent,
    DateRangeSelector,
  },
  props: {
    sn: {
      type: String,
      required: true,
    },
    unpaired: {
      type: Boolean,
      required: true,
      default: false,
    },
    brandName: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      isDemo,
      selectorMode: 'day', // 'day' | 'range';
      selectorRange: {
        from: null,
        to: null,
      },
      dateFrom: null,
      dateTo: null,
      highlightTime: null,
    };
  },
  computed: {
    unit() {
      if (isDemo()) {
        return getChartDemoData(this.brandName);
      }
      return this.unitBySerialNumber;
    },
  },
  watch: {
    'unit.chartData': function () {
      this.updateUrlQuery();
    },
  },
  created() {
    this.loadUrlQueryOrSetToday();
  },
  apollo: {
    unitBySerialNumber: {
      query: ViewQuery,
      variables() {
        return {
          sn: this.sn,
          dateFrom: ( this.dateFrom ) ? this.dateFrom.toISOString() : null,
          dateTo: (this.dateTo) ? this.dateTo.toISOString() : null,
        };
      },
      skip() {
        return !this.sn || !this.dateFrom || !this.dateTo || this.unpaired || isDemo();
      },
    },
  },
  methods: {
    async updateDates() {
      await this.$nextTick();
      if (this.selectorRange.to) {
        this.dateFrom = new Date(this.selectorRange.from);
        this.dateTo = new Date(this.selectorRange.to);
        this.highlightTime = null;
        this.updateUrlQuery();
      }
    },
    /// todo: fix query date
    updateUrlQuery() {
      const url = new URL(window.location.href);
      url.searchParams.set('dateFrom', this.dateFrom.getTime().toString());
      url.searchParams.set('dateTo', this.dateTo.getTime().toString());
      url.searchParams.set('mode', this.selectorMode);
      window.history.replaceState({}, '', url);
    },
    loadUrlQueryOrSetToday() {
      // loads url query or sets today as default
      const url = new URL(window.location.href);
      const from = url.searchParams.get('dateFrom');
      const to = url.searchParams.get('dateTo');
      const mode = url.searchParams.get('mode');
      const highlight = url.searchParams.get('highlight');
      if (from) {
        this.dateFrom = new Date(parseInt(from));
        this.selectorRange.from = this.dateFrom.toISOString();
      } else {
        const dateFrom = new Date();
        dateFrom.setHours(0, 0, 0, 0);
        this.dateFrom = dateFrom;
        this.selectorRange.from = this.dateFrom.toISOString();
      }
      if (to) {
        this.dateTo = new Date(parseInt(to));
        this.selectorRange.to = this.dateTo.toISOString();
      } else {
        const dateTo = new Date();
        dateTo.setHours(24, 0, 0, 0);
        this.dateTo = dateTo;
        this.selectorRange.to = this.dateTo.toISOString();
      }
      if (mode) {
        this.selectorMode = mode;
      } else {
        this.selectorMode = 'day';
      }
      if (highlight) {
        this.highlightTime = new Date(parseInt(highlight));
      } else {
        this.highlightTime = null;
      }
      this.updateUrlQuery();
    },
  },
};
</script>

<template>
  <div>
    <DateRangeSelector
      v-model:date-from="selectorRange.from"
      v-model:date-to="selectorRange.to"
      v-model:mode="selectorMode"
      :show-month="false"
      :range-limit="9"
      :disabled="isDemo()"
      :disabled-label="isDemo() ? $t('unit.dateRangeSelector.demoDisabled') : null"
      @update="updateDates()"
    />

    <ChartWrapper
      :chart-data="unit?.chartData || []"
      :chart-timeline-events="unit?.chartTimelineEvents || []"
      :interval-start="dateFrom"
      :interval-end="dateTo"
      :loading="$apollo.loading"
      :highlight-time="highlightTime"
    />
  </div>
</template>

<style lang="scss" scoped>
.reset-date {
  cursor: pointer;
}
</style>
